
import { Link } from 'react-router-dom';

const CategoriesSection = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-16">
          <div>
            <h2 className="text-5xl font-bold text-gray-900 mb-4">
              Le Nostre<br />Categorie
            </h2>
          </div>
          <div className="max-w-md">
            <p className="text-lg text-gray-600 leading-relaxed">
              Soluzioni tecnologiche complete per rivenditori, system integrator e aziende
            </p>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <Link to="/prodotti" className="group cursor-pointer">
            <div className="bg-gradient-to-b from-gray-50 to-white rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition-all border border-gray-200">
              <div className="h-64 bg-cover bg-center overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/b14017ec710fb65d779330dda40ce05d.jpg"
                  alt="Computer e Notebook"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                  Computer & Notebook
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Laptop professionali, desktop, workstation e componenti PC di ultima generazione per ogni esigenza aziendale.
                </p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-blue-600 mr-2"></i>
                    Laptop Business e Gaming
                  </li>
                  <li className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-blue-600 mr-2"></i>
                    Desktop e Workstation
                  </li>
                  <li className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-blue-600 mr-2"></i>
                    Componenti e Upgrade
                  </li>
                  <li className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-blue-600 mr-2"></i>
                    Monitor e Periferiche
                  </li>
                </ul>
                <div className="flex items-center text-blue-600 font-semibold cursor-pointer">
                  Esplora Categoria
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                </div>
              </div>
            </div>
          </Link>
          
          <Link to="/prodotti" className="group cursor-pointer">
            <div className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition-all border border-gray-200">
              <div className="pt-8 text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 px-8">
                  Smartphone & Tablet
                </h3>
              </div>
              <div className="h-64 flex items-center justify-center px-8">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20smartphone%20standing%20vertically%20on%20clean%20white%20surface%20latest%20mobile%20phone%20with%20sleek%20design%20minimalist%20product%20photography%20premium%20smartphone%20with%20large%20screen%20simple%20neutral%20background%20professional%20tech%20product%20shot%20emphasizing%20mobile%20device%20elegance&width=400&height=500&seq=amaca-cat-smartphones-004&orientation=portrait"
                  alt="Smartphone e Tablet"
                  className="max-h-full w-auto object-contain group-hover:scale-110 transition-transform duration-500 drop-shadow-2xl"
                />
              </div>
              <div className="p-8 pt-4">
                <p className="text-gray-600 mb-6 leading-relaxed text-center">
                  Dispositivi mobile di ultima generazione per comunicazione e produttività aziendale.
                </p>
                <div className="flex justify-center">
                  <span className="inline-flex items-center px-4 py-2 bg-blue-50 text-blue-600 rounded-full text-sm font-medium">
                    <i className="ri-star-line mr-2"></i>
                    Novità
                  </span>
                </div>
              </div>
            </div>
          </Link>
          
          <Link to="/prodotti" className="group cursor-pointer">
            <div className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition-all border border-gray-200">
              <div className="pt-8 text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 px-8">
                  Software & Licenze
                </h3>
              </div>
              <div className="h-64 flex items-center justify-center px-8">
                <div className="grid grid-cols-2 gap-6">
                  <div className="w-24 h-24 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                    <i className="ri-windows-fill text-4xl text-white"></i>
                  </div>
                  <div className="w-24 h-24 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                    <i className="ri-file-word-fill text-4xl text-white"></i>
                  </div>
                  <div className="w-24 h-24 bg-gradient-to-br from-red-500 to-pink-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                    <i className="ri-database-2-fill text-4xl text-white"></i>
                  </div>
                  <div className="w-24 h-24 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                    <i className="ri-shield-check-fill text-4xl text-white"></i>
                  </div>
                </div>
              </div>
              <div className="p-8 pt-4">
                <p className="text-gray-600 mb-6 leading-relaxed text-center">
                  Licenze software originali per sistemi operativi, produttività e sicurezza.
                </p>
                <div className="flex justify-center">
                  <span className="inline-flex items-center px-4 py-2 bg-green-50 text-green-600 rounded-full text-sm font-medium">
                    <i className="ri-shield-check-line mr-2"></i>
                    Licenze Originali
                  </span>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
